import { z } from 'zod'
import { useApiMutation } from '../../utils/useApi'

// ============================================
// POST /control_switch
// ============================================

const ControlSwitchRequestSchema = z
    .object({
        device_name: z.string().min(1, 'device_name is required')
    })
    .strict()

const ControlSwitchResponseSchema = z.object({
    message: z.string()
})

export type ControlSwitchRequest = z.infer<typeof ControlSwitchRequestSchema>
export type ControlSwitchResponse = z.infer<typeof ControlSwitchResponseSchema>

export { ControlSwitchRequestSchema, ControlSwitchResponseSchema }

export const useControlSwitchMutation = () =>
    useApiMutation<ControlSwitchRequest, typeof ControlSwitchResponseSchema>(
        '/access-control/control_switch',
        ControlSwitchResponseSchema
    )
